/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/unbound-method */
import {
  Component,
  Inject,
  Input,
  OnInit,
  Optional,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { RemarksActionService } from '../remarks-action.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AsyncDataService } from 'src/app/digigov/services/async-data.service';
import { Observable } from 'rxjs';
import { AppInitService } from 'src/app/digigov/services/app-init.service';
import { tap } from 'rxjs/operators';
import { DgFileUploadComponent } from 'dg-file-upload-lib';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';

@Component({
  selector: 'tagged-action-form',
  templateUrl: './tagged-action-form.component.html',
  styleUrls: ['./tagged-action-form.component.scss'],
})
export class TaggedActionFormComponent implements OnInit {
  @ViewChild('dgFileUpload') dgFileUpload: DgFileUploadComponent;

  taggedAction: FormGroup;
  selectedTagType: any = [];
  selectedCCType: any = [];
  myselectedtaggedemps: any[];
  myselectedccemps: any[];
  worktrayList: any[];
  showTaggedEmp: boolean = false;
  showCC: boolean = false;
  //empsearch
  showFilter = true;
  selectedEmployeeList1 = [];
  selectedEmployeeList2 = [];
  isDisplayLoginEmp = false;

  empConfig1 = {
    multiSelect: false,
    header: 'select-taggedto',
    subTitle: 'Recipients',
    selectedSubTitle: 'Selected Employees',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
  };
  empConfig2 = {
    multiSelect: false,
    header: 'select-cc-employee',
    subTitle: 'Recipients',
    selectedSubTitle: 'Selected Employees',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
  };
  orgConfig = {
    prntId: '54',
    fetchPrntOrgOnlyFlag: 'false',
    multiselect: false,
    header: 'Organization Search',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters ',
  };
  showBroadcastEmp: boolean = false;
  showBroadcastGrp: boolean = false;
  myAssignedEmps = [];
  myAssignedSupervisor: any;
  //attachment component
  appMaxSize = 5;
  appMaxFiles = 5;
  multipleAllowed = true;
  isEdit = true;
  appAttachID = '';
  attachmentTitle = ''; //title
  attachmentID = 'Attach'; //any name for attchment component
  isMandatory = false;
  isAllowUpdate = true; //ignore it as currently not in use
  isAllowFileToAttach = true; //to restrict from uploading doc
  isAllowDelete = true; //to restrict from deleting any doc
  attachSmall = true;
  isDownload = true;
  appAcceptedType = [
    'pdf',
    'png',
    'doc',
    'jpeg',
    'jpg',
    'xlsx',
    'csv',
    'docx',
    'xls',
    'mp4',
    '3gp',
  ];
  isRefresh = true;
  attachPath: any;
  fillForm: boolean = true;
  @Input() caseDetails?;

  taggedActionFormData: any;
  showattachment: boolean = true;
  assignSupervisorType: any;
  asyncData$: Observable<string>;
  attachmentfortp: boolean = false;
  selectedNotifTypes: any = [];
  selectedRepeat: any = [];
  repeatYes: boolean = false;
  repeatNo: boolean = false;
  today = new Date();
  defaultStartTime = ['00', '00'];
  repeatValues = [
    {
      optionValue: '101',
      optionText: 'Day(s)',
    },
    {
      optionValue: '102',
      optionText: 'Hour(s)',
    },
    {
      optionValue: '103',
      optionText: 'Minute(s)',
    },
  ];
  constructor(
    private service: RemarksActionService,

    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: {
      from?: string;
      image64?: boolean;
      other?: boolean;
    },
    private dialog: MatDialog,
    private asyncDataService: AsyncDataService,
    public appInitService: AppInitService
  ) {
    console.log('data dialog', data);
    if (data?.image64) {
      this.asyncData$ = this.asyncDataService.getScreenshotString().pipe(
        tap((imageString: string) => {
          if (imageString) {
            this.uploadScreenShot(imageString);
            this.asyncDataService.setScreenshotString(null);
          }
        })
      );
    }
  }

  ngOnInit(): void {
    console.log('forminfo', this.caseDetails);
    this.selectedNotifTypes = [111];
    this.selectedRepeat = [12];

    this.getWorktrayCombo();
    this.taggedAction = new FormGroup({
      taggedTo: new FormControl<Number[]>([], Validators.required),
      taggedToEmp: new FormControl(null, Validators.required),
      ccTo: new FormControl<Number[]>([]),
      worktray: new FormControl(null, Validators.required),
      ccToEmp: new FormControl(null, Validators.required),
      subject: new FormControl(null, Validators.required),
      comments: new FormControl(null, Validators.required),
      notifType: new FormControl<Number[]>([]),
      // desc: new FormControl('', Validators.required),
      remRepeat: new FormControl<Number[]>([]),
      startOn: new FormControl(null),
      until: new FormControl(null),
      repeatEvery: new FormControl(null),
      optionSelect: new FormControl(null),
      remindsOn: new FormControl(null),
    });
    if (this.caseDetails && this.caseDetails.basicInfoURL) {
      this.fillForm = false;
      this.taggedAction.disable();

      this.getPopulateFormDataCorrID(this.caseDetails?.corrID);
    } else if (this.caseDetails && this.caseDetails.remarkActionId) {
      this.fillForm = false;
      this.taggedAction.disable();

      this.getPopulateFormData(this.caseDetails?.remarkActionId);
    } else {
      this.taggedAction.controls['taggedTo'].valueChanges.subscribe((value) => {
        if (value === '1') {
          this.taggedAction.controls['taggedToEmp'].enable();
        }
        if (value === '0') {
          this.taggedAction.controls['taggedToEmp'].disable();
        }
      });
      this.taggedAction.controls['broadcastTo'].valueChanges?.subscribe(
        (value) => {
          if (value === '1') {
            this.taggedAction.controls['ccToEmp'].enable();
            this.taggedAction.controls['worktray'].disable();
          }
          if (value === '2') {
            this.taggedAction.controls['worktray'].enable();
            this.taggedAction.controls['ccToEmp'].disable();
          }
        }
      );
    }
  }
  //base64 to Image
  DataURIToBlob(dataURI: string): Blob {
    const splitDataURI = dataURI.split(',');
    const byteString =
      splitDataURI[0].indexOf('base64') >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    return new Blob([ia], { type: mimeString });
  }
  uploadScreenShot(value: string): void {
    const formData: FormData = new FormData();
    const dataFile = new File(
      [this.DataURIToBlob(value)],
      'auto-captured-screenshot.png',
      {
        type: 'image/png',
      }
    );
    this.attachmentfortp = this.appInitService?.appConfig?.configurableFields?.attachmentForTP;
    if (this.attachmentfortp == false) {
      this.dgFileUpload.uploadFile([dataFile]);
    }
  }
  //get data for populate form
  getPopulateFormData(remarkActionId) {
    this.service.getPopulateFormData(remarkActionId).subscribe((res: any) => {
      this.taggedActionFormData = res.data;
      console.log('formdata is', this.taggedActionFormData);
      this.taggedAction?.controls['subject']?.setValue(
        this.taggedActionFormData?.subject
      );
      this.taggedAction?.controls['comments']?.setValue(
        this.taggedActionFormData?.remarks
      );
      if (this.taggedActionFormData.attachId != 0) {
        this.showattachment = true;
        this.isAllowDelete = false;
        this.isAllowFileToAttach = false;
        this.isAllowUpdate = false;
        this.appAttachID = this.taggedActionFormData.attachId;
        this.attachmentID = this.taggedActionFormData.attachId;
      } else {
        this.showattachment = false;
      }
      //for tagged to populate
      if (this.taggedActionFormData.assignType == 1) {
        this.showTaggedEmp = true;
        this.taggedAction?.controls['taggedTo']?.setValue(
          this.taggedActionFormData.assignType
        );
      } else if (this.taggedActionFormData.assignType == 0) {
        this.taggedAction?.controls['taggedTo']?.setValue(
          this.taggedActionFormData.assignType
        );
      }
      //tagged to emp populate
      if (this.taggedActionFormData.assignType == 1) {
        this.selectedEmployeeList1.push(this.taggedActionFormData.assignId);
      }

      //for CC To populate
      if (this.taggedActionFormData.assignSupervisorType == 0) {
        this.showCC = false;
      } else if (this.taggedActionFormData.assignSupervisorType == 1) {
        this.showCC = true;
        this.taggedAction?.controls['ccTo']?.setValue(
          this.taggedActionFormData.assignSupervisorType
        );
      } else if (this.taggedActionFormData.assignSupervisorType == 2) {
        this.showCC = true;
        this.taggedAction?.controls['ccTo']?.setValue(
          this.taggedActionFormData.assignSupervisorType
        );
      }
      //ccto emp populate
      if (this.taggedActionFormData.assignSupervisorType == 1) {
        this.showBroadcastEmp = true;
        this.selectedEmployeeList2.push(
          this.taggedActionFormData.assignSupervisorId
        );
      }
      //ccto group populate
      if (this.taggedActionFormData.assignSupervisorType == 2) {
        this.showBroadcastGrp = true;
        if (this.worktrayList) {
          this.worktrayList.forEach((element: any) => {
            if (
              element.optionValue ===
              this.taggedActionFormData.assignSupervisorId.toString()
            ) {
              this.taggedAction?.controls['worktray']?.setValue(
                element.optionText
              );
            }
          });
        }
      }

      //notification type populate
      //  for (let event of this.taggedActionFormData.eventTrnDtlVO
      //    .eventTrnNtfcnVOs) {
      //    if (event.ntfcnType == 111) {
      //      this.taggedAction?.controls['desc']?.setValue(
      //        event.ntfcnContent
      //      );
      //    }
      //    if (event.ntfcnType == 113) {
      //      this.taggedAction?.controls['desc']?.setValue(event.ntfcnContent);

      //    }
      //    if (event.ntfcnType == 112) {
      //      this.taggedAction?.controls['desc']?.setValue(event.ntfcnContent);

      //    }
      //  }
    });
  }
  getPopulateFormDataCorrID(corrId) {
    this.service.getPopulateFormDataCorrID(corrId).subscribe((res: any) => {
      this.taggedActionFormData = res.data;
      console.log('formdata is', this.taggedActionFormData);
      this.taggedAction?.controls['subject']?.setValue(
        this.taggedActionFormData?.subject
      );
      this.taggedAction?.controls['comments']?.setValue(
        this.taggedActionFormData?.remarks
      );
      if (this.taggedActionFormData.attachId != 0) {
        this.showattachment = true;
        this.isAllowDelete = false;
        this.isAllowFileToAttach = false;
        this.isAllowUpdate = false;
        this.appAttachID = this.taggedActionFormData.attachId;
        this.attachmentID = this.taggedActionFormData.attachId;
      } else {
        this.showattachment = false;
      }
      //for tagged to populate
      if (this.taggedActionFormData.assignType == 1) {
        this.showTaggedEmp = true;
        this.taggedAction?.controls['taggedTo']?.setValue(
          this.taggedActionFormData.assignType
        );
      } else if (this.taggedActionFormData.assignType == 0) {
        this.taggedAction?.controls['taggedTo']?.setValue(
          this.taggedActionFormData.assignType
        );
      }
      //tagged to emp populate
      if (this.taggedActionFormData.assignType == 1) {
        this.selectedEmployeeList1.push(this.taggedActionFormData.assignId);
      }

      //for CC To populate
      if (this.taggedActionFormData.assignSupervisorType == 0) {
        this.showCC = false;
      } else if (this.taggedActionFormData.assignSupervisorType == 1) {
        this.showCC = true;
        this.taggedAction?.controls['ccTo']?.setValue(
          this.taggedActionFormData.assignSupervisorType
        );
      } else if (this.taggedActionFormData.assignSupervisorType == 2) {
        this.showCC = true;
        this.taggedAction?.controls['ccTo']?.setValue(
          this.taggedActionFormData.assignSupervisorType
        );
      }
      //ccto emp populate
      if (this.taggedActionFormData.assignSupervisorType == 1) {
        this.showBroadcastEmp = true;
        this.selectedEmployeeList2.push(
          this.taggedActionFormData.assignSupervisorId
        );
      }
      //ccto group populate
      if (this.taggedActionFormData.assignSupervisorType == 2) {
        this.showBroadcastGrp = true;
        if (this.worktrayList) {
          this.worktrayList.forEach((element: any) => {
            if (
              element.optionValue ===
              this.taggedActionFormData.assignSupervisorId.toString()
            ) {
              this.taggedAction?.controls['worktray']?.setValue(
                element.optionText
              );
            }
          });
        }
      }
    });
  }
  //Tagged to toggle button
  onChangeTaggedTo(tagType) {
    this.myselectedtaggedemps = [];
    this.taggedAction.controls['taggedToEmp'].setValue(null);
    this.taggedAction.get('ccTo').reset();
    this.myselectedccemps = [];
    this.taggedAction.controls['ccToEmp'].setValue(null);
    this.taggedAction.get('worktray').reset();
    this.taggedAction.controls['ccToEmp'].disable();
    this.taggedAction.controls['worktray'].disable();
    this.showBroadcastEmp = false;
    this.showBroadcastGrp = false;
    this.selectedTagType = tagType;
    if (tagType == 1) {
      this.showTaggedEmp = true;
      this.showCC = true;
      this.taggedAction.controls['taggedToEmp'].enable();
      this.taggedAction.controls['ccTo'].enable();
    } else if (tagType == 0) {
      this.showTaggedEmp = false;
      this.showCC = false;
      this.taggedAction.controls['taggedToEmp'].disable();
      this.taggedAction.controls['ccTo'].disable();
    } else {
      this.showTaggedEmp = false;
      this.showCC = false;
    }
  }

  //Tagged to employee search
  onChangeEmpTagged(TaggedEmp): void {
    this.myselectedtaggedemps = [];
    this.taggedAction.controls['taggedToEmp'].setValue(null);
    if (TaggedEmp.length != 0) {
      for (let s of TaggedEmp) {
        this.myselectedtaggedemps.push(s.UNIT_ID);
      }
      this.taggedAction.controls['taggedToEmp'].setValue(
        this.myselectedtaggedemps
      );
    } else {
      this.taggedAction.controls['taggedToEmp'].setValue(null);
    }
    this.taggedAction.updateValueAndValidity();
  }
  getDataEmpTagged(taggedEmp): void {
    this.myselectedtaggedemps = [];
    if (taggedEmp.length != 0) {
      for (let s of taggedEmp) {
        this.myselectedtaggedemps.push(s.UNIT_ID);
      }
      this.taggedAction.controls['taggedToEmp'].setValue(
        this.myselectedtaggedemps
      );
    } else {
      this.taggedAction.controls['taggedToEmp'].setValue(null);
    }
    this.taggedAction.updateValueAndValidity();
  }

  //CC to Toggle
  onChangeCC(ccType) {
    this.myselectedccemps = [];
    this.taggedAction.controls['ccToEmp'].setValue(null);
    this.taggedAction.get('worktray').reset();
    this.selectedCCType = ccType;
    if (ccType == 2) {
      this.showBroadcastEmp = false;
      this.showBroadcastGrp = true;
      this.taggedAction.controls['ccToEmp'].disable();
      this.taggedAction.controls['worktray'].enable();
    } else if (ccType == 1) {
      this.showBroadcastEmp = true;
      this.showBroadcastGrp = false;
      this.taggedAction.controls['ccToEmp'].enable();
      this.taggedAction.controls['worktray'].disable();
    } else {
      this.showBroadcastEmp = false;
      this.showBroadcastGrp = false;
    }
  }
  //CC to employee search
  onChangeEmpCC(ccEmp): void {
    this.myselectedccemps = [];
    this.taggedAction.controls['ccToEmp'].setValue(null);
    if (ccEmp.length != 0) {
      for (let s of ccEmp) {
        this.myselectedccemps.push(s.UNIT_ID);
      }
      this.taggedAction.controls['ccToEmp'].setValue(this.myselectedccemps);
    } else {
      this.taggedAction.controls['ccToEmp'].setValue(null);
    }
    this.taggedAction.updateValueAndValidity();
  }
  getDataEmpCC(ccEmp): void {
    this.myselectedccemps = [];
    if (ccEmp.length != 0) {
      for (let s of ccEmp) {
        this.myselectedccemps.push(s.UNIT_ID);
      }
      this.taggedAction.controls['ccToEmp'].setValue(this.myselectedccemps);
    } else {
      this.taggedAction.controls['ccToEmp'].setValue(null);
    }
    this.taggedAction.updateValueAndValidity();
  }

  //Notification Type Toggle change
  onChangeNotifType(notifType) {
    console.log('selected notif type', notifType);
    this.selectedNotifTypes = notifType;
  }
  //Repeat Toggle change
  onChangeRepeat(repeatType) {
    console.log(' repeat type', repeatType);
    this.taggedAction.get('startOn').setValue(null);
    this.taggedAction.get('until').setValue(null);
    this.taggedAction.get('repeatEvery').setValue(null);
    this.taggedAction.get('optionSelect').setValue(null);
    this.taggedAction.get('remindsOn').setValue(null);

    this.repeatYes = false;
    this.repeatNo = false;
    if (repeatType == 11) {
      this.repeatYes = true;
      this.repeatNo = false;
      this.taggedAction.get('startOn').setValidators([Validators.required]);
      this.taggedAction.get('startOn').updateValueAndValidity();
      // this.taggedAction.get('until').setValidators([Validators.required]);
      // this.taggedAction.get('until').updateValueAndValidity();
      this.taggedAction.get('repeatEvery').setValidators([Validators.required]);
      this.taggedAction.get('repeatEvery').updateValueAndValidity();
      this.taggedAction
        .get('optionSelect')
        .setValidators([Validators.required]);
      this.taggedAction.get('optionSelect').updateValueAndValidity();
      this.taggedAction.get('remindsOn').clearValidators();
      this.taggedAction.get('remindsOn').updateValueAndValidity();
    } else if (repeatType == 12) {
      this.repeatYes = false;
      this.repeatNo = true;
      this.taggedAction.get('startOn').clearValidators();
      this.taggedAction.get('startOn').updateValueAndValidity();
      // this.taggedAction.get('until').clearValidators();
      // this.taggedAction.get('until').updateValueAndValidity();
      this.taggedAction.get('repeatEvery').clearValidators();
      this.taggedAction.get('repeatEvery').updateValueAndValidity();
      this.taggedAction.get('optionSelect').clearValidators();
      this.taggedAction.get('optionSelect').updateValueAndValidity();
      this.taggedAction.get('remindsOn').setValidators([Validators.required]);
      this.taggedAction.get('remindsOn').updateValueAndValidity();
    }
  }
  //File Upload
  onFinalPath(finalPath: Event): void {
    //Will provide the finalPath for first component
    console.log('finalPath>>>>', finalPath);
    this.attachPath = finalPath;
  }
  onSubmit() {
    if (this.taggedAction.valid) {
      if (this.taggedAction.controls['taggedTo']?.value == 0) {
        this.myAssignedEmps = null;
      } else {
        this.myAssignedEmps = this.myselectedtaggedemps[0];
      }
      if (this.taggedAction.controls['taggedTo']?.value == 1) {
        if (this.taggedAction.controls['ccTo']?.value) {
          this.assignSupervisorType = this.taggedAction.controls['ccTo']?.value;
          if (this.taggedAction.controls['ccTo']?.value == 1) {
            this.myAssignedSupervisor = this.myselectedccemps[0];
          } else {
            this.myAssignedSupervisor = Number(
              this.taggedAction.controls['worktray'].value.optionValue
            );
          }
        } else {
          this.assignSupervisorType = 0;
        }
      } else {
        this.myAssignedSupervisor = null;
      }
      const selectedNotifType: Number[] = this.selectedNotifTypes;
      const postData = {
        assignType: this.taggedAction.controls['taggedTo']?.value,
        assignId: this.myAssignedEmps,
        assignSupervisorType: this.taggedAction.controls['ccTo']?.value,
        assignSupervisorId: this.myAssignedSupervisor,
        subject: this.taggedAction.controls['subject']?.value,
        remarks: this.taggedAction.controls['comments']?.value,
        attachReference: this.attachPath,
        eventTrnDtlVO: {
          eventTrnNtfcnScheduleVO: {
            ntfcnStartTime: this.taggedAction.controls['startOn']?.value
              ? this.taggedAction.controls['startOn']?.value
              : this.taggedAction.controls['remindsOn']?.value,
            ntfcnEndTime: this.taggedAction.controls['until']?.value,
            ntfcnRepeatType: this.taggedAction.controls['optionSelect']?.value,
            ntfcnRepeatValue: this.taggedAction.controls['repeatEvery']?.value,
          },
          eventTrnNtfcnVOs: selectedNotifType.map((comTypeId) => {
            let comJson = {
              ntfcnType: comTypeId,
              ntfcnContent: '',
              activeFlag: 1,
            };
            if (comTypeId === 113) {
              comJson['ntfcnContent'] = this.taggedAction.controls[
                'comments'
              ]?.value;
            }
            if (comTypeId === 111) {
              comJson['ntfcnContent'] = this.taggedAction.controls[
                'comments'
              ]?.value;
            }
            if (comTypeId === 112) {
              comJson['ntfcnContent'] = this.taggedAction.controls[
                'comments'
              ]?.value;
            }
            return comJson;
          }),
        },
      };
      console.log('postData', postData);
      this.service.createTaggedAction(postData).subscribe((res) => {
        const restemp: any = res;
        console.log(restemp);

        this.onClose();
      });
    }
  }
  setMinDateForPickerAccStartDate(startVal): Date {
    // this.today = new Date();
    return new Date(new Date(startVal).getTime() + 1000 * 60);
  }
  endTimeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const startTime = this.taggedAction?.controls?.['startOn']?.value;
      const endTime = this.taggedAction?.controls?.['until']?.value;

      if (startTime < endTime) {
        return null;
      }

      return {
        timeError: true,
      };
    };
  }
  onClose() {
    this.dialog.closeAll();
    this.onReset();
  }
  onReset() {
  
    this.taggedAction?.reset();
    this.showTaggedEmp = false;
    this.showCC = false;
    this.showBroadcastEmp = false;
    this.showBroadcastGrp = false;
    this.appAttachID = '';
    this.attachmentID = '';
    this.isRefresh = !this.isRefresh;
 
    this.repeatNo = false;
    this.repeatYes = false;
    this.selectedNotifTypes = [111];
  }
  getWorktrayCombo() {
    const dataforpost = {
      ComboId: '20004',
    };
    this.service.getCombo(dataforpost).subscribe((res) => {
      this.worktrayList = res.data;
    });
  }
}
